import { Heading, Paragraph, Text } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';
import { formatDate } from '../../../../../utils/formatters';
import { getIsMoveInDateValid } from '../../../../../constants/validation';

interface Props {
  answers: Answers;
  isReadOnly?: boolean;
}

const fieldsInStep = [FIELD_IDS.MOVE_IN_DATE, FIELD_IDS.MOVE_IN_FLEXIBLE];

export function MoveInDateOverview({ answers, isReadOnly }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers });

  return (
    <>
      {answersForFields[FIELD_IDS.MOVE_IN_DATE] && (
        <>
          <Heading level={6} marginY="xs">
            Requested move-in date
          </Heading>
          <Paragraph>{formatDate(answersForFields[FIELD_IDS.MOVE_IN_DATE] as string)}</Paragraph>
          {!getIsMoveInDateValid({ answers }) && !isReadOnly && (
            <Paragraph fontColor="red500" fontType="bodySmall">
              Date must be in the future
            </Paragraph>
          )}
        </>
      )}
      {answersForFields[FIELD_IDS.MOVE_IN_FLEXIBLE] && (
        <>
          <Heading level={6} marginY="xs">
            Is move-in date flexible
          </Heading>
          <Text>{answersForFields[FIELD_IDS.MOVE_IN_FLEXIBLE]}</Text>
        </>
      )}
    </>
  );
}
